module.exports = __webpack_public_path__ + "static/media/bottom-underlay.67469001.png";